import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../Navbar'
import PageTitle from '../pagetitle'
import BookingForm from '../BookingForm'
import Footer from '../footer'
import Scrollbar from '../scrollbar'
import hifzImg from '../../images/service/service/Hifz.webp'
import hifzDetail from '../../images/service/service-sub-pages/Hifz.jpg'
import banner4 from '../../images/banners/4.webp'
import './style.css'

const Hifz = () => {
    const ClickHandler = (e) => {
        const hash = e.currentTarget.hash;
        if (hash === '#booking-form') {
            e.preventDefault();
            const element = document.getElementById('booking-form');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            window.scrollTo(10, 0);
        }
    }

    return (
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={'Hifz'} pagesub={'Service'} backgroundImage={banner4} hideText={true}/>
            <section className="service-single-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-8 col-md-12 col-12">
                            <div className="service-single-content">
                                <div className="service-single-img">
                                    <img src={hifzImg} alt="Hifz - Quran Memorisation"/>
                                </div>
                                <h2 className="service-title"> <span>Hifz</span> <br/> (Quran Memorisation)</h2>
                                <div className="service-description">
                                    <p>Embark on the noble journey of committing the Quran to memory with our structured and supportive Hifz program. Whether you wish to memorize selected surahs or aspire to become a Hafiz/Hafiza of the entire Quran, our comprehensive approach combines traditional memorization techniques with modern teaching methods to make this significant undertaking achievable for students of all ages.</p>
                                </div>
                                
                                <div className="service-single-inner">
                                    <span><img src={hifzDetail} alt="Hifz Memorisation Process"/></span>
                                    <div className="service-single-tb-text">
                                        <h3 className="service-section-title"><i className="fi flaticon-book"></i> Course Content</h3>
                                        <ul className="service-features-list">
                                            <li>Tajweed complete Rules of Hifz - proper pronunciation during memorization</li>
                                            <li>Revisions - strategic review schedules to maintain memorized portions</li>
                                            <li>Proper Assessment - regular evaluation of memorization quality and retention</li>
                                            <li>Testing - periodic examinations to ensure strong memorization</li>
                                            <li>Recitation - beautiful delivery of memorized portions</li>
                                            <li>Systematic memorization approach proceeding surah by surah</li>
                                            <li>Effective memory techniques tailored to different learning styles</li>
                                            <li>Connection with meanings to aid memory retention</li>
                                            <li>Regular revision plans to maintain memorization long-term</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-teacher"></i> Recommended Format</h3>
                                    <div className="service-section-content">
                                        <p>We offer both one-to-one and small group options for Hifz, with individual tutoring particularly recommended for serious memorization students. One-to-one sessions allow:</p>
                                        <ul className="service-features-list">
                                            <li>Personalized pace according to each student's memory capacity</li>
                                            <li>Detailed attention to accurate pronunciation during memorization</li>
                                            <li>Customized revision schedules based on individual strengths</li>
                                            <li>Flexible advancement through the curriculum</li>
                                        </ul>
                                        <p>Our small group option works well for motivated students who benefit from peer encouragement and healthy competition.</p>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-calendar"></i> Optimal Schedule</h3>
                                    <div className="service-section-content">
                                        <p>Effective Hifz requires consistent practice and regular review:</p>
                                        <ul className="service-features-list">
                                            <li>Multiple sessions</li>
                                            <li>Weekly teacher meetings to verify accuracy and progress</li>
                                            <li>Flexible scheduling that works around school and other commitments</li>
                                            <li>Long-term commitment with achievable milestones</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-money-bag"></i> Course Fees</h3>
                                    <div className="service-section-content">
                                        <div className="pricing-table">
                                            <div className="pricing-option">
                                                <h4>3 Days per Week</h4>
                                                <div className="price">£35<span>/month</span></div>
                                                <p>Steady approach for long-term memorization</p>
                                            </div>
                                            <div className="pricing-option featured">
                                                <h4>4 Days per Week</h4>
                                                <div className="price">£45<span>/month</span></div>
                                                <p>Recommended for consistent progress</p>
                                            </div>
                                            <div className="pricing-option">
                                                <h4>5 Days per Week</h4>
                                                <div className="price">£55<span>/month</span></div>
                                                <p>Intensive program for dedicated students</p>
                                            </div>
                                        </div>
                                        <p className="pricing-note">All packages include expert memorization guidance, personalized revision schedules, regular assessments, and certification upon completion of sections. Special rates available for students committing to complete Quran memorization.</p>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-lotus"></i> Benefits of Our Hifz Program</h3>
                                    <div className="service-section-content">
                                        <ul className="service-features-list">
                                            <li>Expert supervision ensuring accuracy in memorization from the beginning</li>
                                            <li>Progressive achievement system with certificates for major milestones</li>
                                            <li>Development of strong memory skills applicable to all areas of learning</li>
                                            <li>Spiritual connection through deep engagement with Quranic text</li>
                                            <li>Community recognition and special status upon completion</li>
                                            <li>Proven methodology based on centuries of traditional Hifz teaching</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-conclusion">
                                    <p>Our Hifz program is designed to transform what might seem like an overwhelming task into an achievable goal through systematic progression and consistent support. We encourage and motivate students through every step of their journey, celebrating small victories and building toward complete memorization. Our qualified Huffaz teachers provide not just technical guidance but also spiritual inspiration, helping students develop a profound connection with the words they are memorizing.</p>
                                </div>
                                
                                <div className="btns text-center mt-5">
                                    <Link onClick={ClickHandler} to="/home#booking-form" className="theme-btn">Book a Free Trial Class</Link>
                                </div>
                            </div>
                            
                            <div className="prv-nx">
                                <div className="pre-btn"><Link onClick={ClickHandler} to="/tajweed-improvement">Previous: Tajweed Improvement</Link></div>
                                <div className="nex-btn"><Link onClick={ClickHandler} to="/class-options">Next: Class Options</Link></div>
                            </div>
                        </div>
                        
                        <div className="col col-lg-4 col-md-12 col-12">
                            <div className="service-sidebar">
                                <div className="widget service-list-widget">
                                    <h3>All Services</h3>
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="/basic-qaida">Basic Qaida (Beginner Quran Reading)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/tajweed">Tajweed (Quran Recitation Rules)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/tajweed-improvement">Tajweed Improvement (Advanced)</Link></li>
                                        <li className="current"><Link to="/hifz">Hifz (Quran Memorisation)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/class-options">Class Options</Link></li>
                                        <li><Link onClick={ClickHandler} to="/free-demo">Free Demo Class</Link></li>
                                        <li><Link onClick={ClickHandler} to="/assessments">Assessments & Certification</Link></li>
                                    </ul>
                                </div>
                                <div className="widget contact-widget">
                                    <div>
                                        <h4>Book Your Free Trial Class</h4>
                                        <h2><a href="https://wa.me/message/UTB4XLJQLZ22M1">+44 784 035 7821</a></h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BookingForm/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
}

export default Hifz; 